import { RESPONSIVE_EXTRA_LARGE, RESPONSIVE_LARGE, RESPONSIVE_MEDIUM, RESPONSIVE_SMALL } from 'constants/responsive';

const isPhone = { maxWidth: RESPONSIVE_SMALL };
const isTablet = { maxWidth: RESPONSIVE_MEDIUM };
const isLaptopSM = { maxWidth: RESPONSIVE_LARGE };
const isLaptopLG = { maxWidth: RESPONSIVE_EXTRA_LARGE };
const isBigScreen = { minWidth: RESPONSIVE_EXTRA_LARGE + 1 };

export default { isPhone, isTablet, isBigScreen, isLaptopLG, isLaptopSM };
